import React from 'react';
import clsx from 'clsx';

import styles from './InputLabel.module.scss';

type InputLabelProps = {
  className?: string;
  text?: string;
  htmlFor?: string
};

export const InputLabel: React.FC<InputLabelProps> = ({ className, text, children, ...props }) => (
  <label {...props} className={clsx(styles.root, className)}>
    {text && <div className={clsx(styles.label, className)}>{text}</div>}
    {children}
  </label>
);
